import { Button } from '@/components';
import { RadixDialog } from '@/components/RadixDialog';
import { MasterTranslation } from '@/constants';
import { useGlobalState, usePreventBodyScroll } from '@/hooks';
import { ButtonSize, ButtonVariant, IconAlignment } from '@/interfaces';
import { useShipmentDetailsContext } from '@/modules/pmt/context';
import { gtmClickRemoveParcel } from '@/utils';
import { ButtonGroup, ButtonTrashIcon, Spinner, TrashIcon } from './RemoveButton.styles';
import { useRemoveShipment } from './useRemoveShipment.hook';

interface IRemoveButton {
  disabled: boolean;
}

export const RemoveButton: React.FC<IRemoveButton> = ({ disabled }) => {
  const { t } = useGlobalState();
  const { onRemoveShipment } = useRemoveShipment();
  const { currentShipment, showDeleteShipment, setShowDeleteShipment } = useShipmentDetailsContext();

  usePreventBodyScroll(showDeleteShipment);

  const toggleDeleteDialog = () => {
    setShowDeleteShipment((prev) => !prev);
  };

  const onButtonClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    if (!disabled && !currentShipment?.isDeleting) {
      gtmClickRemoveParcel();
      toggleDeleteDialog();
    }
  };

  const isDeleting = currentShipment?.isDeleting;

  const renderBtnDeleteText: string = isDeleting ? t(MasterTranslation.Deleting) : t(MasterTranslation.Delete);

  // TODO: @ngan Check if this is needed
  // useEffect(() => {
  //   setShowDeleteParcelBtn(false);
  // }, [currentShipmentDocId, setShowDeleteParcelBtn]);

  const TrashIconButton = (props: React.HTMLAttributes<HTMLDivElement>) => (
    <ButtonTrashIcon aria-label='Delete Parcel' disabled={disabled || isDeleting} onClick={onButtonClick} {...props}>
      <TrashIcon />
    </ButtonTrashIcon>
  );

  return (
    <RadixDialog.WithGraphicWrapper
      open={showDeleteShipment}
      onOpenChange={toggleDeleteDialog}
      trigger={<TrashIconButton />}
    >
      <RadixDialog.Header />
      <RadixDialog.Content>
        <RadixDialog.MainText>{t(MasterTranslation.DeleteParcel)}</RadixDialog.MainText>
        <RadixDialog.SubText>{t(MasterTranslation.DeleteConfirmation)}</RadixDialog.SubText>
        <ButtonGroup>
          <RadixDialog.Close asChild>
            <Button truncate isPMTButton size={ButtonSize.Large} variant={ButtonVariant.Outlined} disabled={isDeleting}>
              {t(MasterTranslation.Cancel).toUpperCase()}
            </Button>
          </RadixDialog.Close>
          <RadixDialog.Close asChild>
            <Button
              truncate
              isPMTButton
              size={ButtonSize.Large}
              onClick={onRemoveShipment}
              icon={isDeleting ? () => <Spinner /> : undefined}
              alignment={IconAlignment.Left}
              disabled={isDeleting}
            >
              {renderBtnDeleteText.toUpperCase()}
            </Button>
          </RadixDialog.Close>
        </ButtonGroup>
      </RadixDialog.Content>
    </RadixDialog.WithGraphicWrapper>
  );
};
